<script setup>
	import { VBtn, VCard, VCardActions, VCardText, VDialog } from "vuetify/components";

	const props = defineProps({
		userPrompt: String,
	});

	const emit = defineEmits([ "confirm", "cancel" ]);

	function raiseConfirmEmit() {
		emit("confirm");
	}
	function raiseCancelEmit() {
		emit("cancel");
	}
</script>

<template>
	<VDialog width="auto" scrim="true" class="confirm-cancel-dialog">
		<VCard>
			<VCardText>{{ props.userPrompt }}</VCardText>
			<VCardActions>
				<VBtn color="primary" class="yes-action" @click="raiseConfirmEmit">Yes</VBtn>
				<VBtn color="secondary" @click="raiseCancelEmit" class="cancel-action">Cancel</VBtn>
			</VCardActions>
		</VCard>
	</VDialog>
</template>
